<shared-spinner></shared-spinner>